import { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";  

import { useLocation } from "react-router-dom";
import PaymentPage from "./Checkout2";
export default function CheckoutPage() {
  const [phone, setPhone] = useState("");
  const [name, setname] = useState("");
  const [email, setemail] = useState("");

  const [form_completed, set_form_completed] = useState(false)

  const navigate = useNavigate();


  const location = useLocation();
  const { ticketCount = 0, total = 0 } = location.state || {};
  useEffect(()=>{
    localStorage.setItem('total',total)
  },[total])

  return (
    <div className="flex items-center md:px-32 justify-center md:py-20 py-6 px-4 bg-white sm:px-6">
      <div className="grid w-full  grid-cols-1 p-4  sm:p-6 sm:grid-cols-2">
        {/* Customer Information */}
        <div className="w-full">
          {form_completed ? (
            <>
                        <div className="bg-white p-8 rounded-lg shadow-lg">
                        <h2 className="mb-4 text-xl font-bold sm:text-2xl">Customer Information</h2>
                        <form className="space-y-4 flex flex-col text-xl ">
               
 
                          <span>{name}</span>
                          <span>{phone}</span>
                          <span>{email}</span>
                        </form>
                      </div>
                        <div className="bg-white p-8 mt-8 rounded-lg shadow-lg">
                        <h2 className="mb-4 text-xl font-bold sm:text-2xl">Customer Information</h2>
                        <PaymentPage />
                      </div>
            </>
          ) : (
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <h2 className="mb-4 text-xl font-bold sm:text-2xl">Customer Information</h2>
              <form className="space-y-4">
     
                <div className="border border-neutral-700 rounded relative">
                  <label className="block absolute left-2 -top-[12px] p-[2px] bg-white z-10 text-xs text-gray-700">Name *</label>
                  <input 
                    type="text" 
                    className="w-full p-2 py-3 text-sm border-neutral-700 border-none rounded sm:text-base" 
                    value={name}
                    onChange={(e)=>setname(e.target.value)}
                  />
                </div>
                <div className="border border-neutral-700 rounded relative">
                  <label className="block absolute left-2 -top-[12px] p-[2px] bg-white z-10 text-xs text-gray-700">Phone *</label>
                  <PhoneInput
                    country={"us"}
                    value={phone}
                    onChange={setPhone}
                    inputClass="w-full p-2  border-none w-full rounded-lg bg-white text-sm sm:text-base"
                    containerClass=" bg-white rounded-lg py-2 "
                  />
                </div>
                <div className="border border-neutral-700 rounded relative">
                  <label className="block absolute left-2 -top-[12px] p-[2px] bg-white z-10 text-xs text-gray-700">Email *</label>
                  <input 
                    type="text" 
                    className="w-full p-2 py-3 text-sm border-neutral-700 border-none rounded sm:text-base" 
                    value={email}
                    onChange={(e)=>setemail(e.target.value)}
                  />
                </div>
                <button  
                  onClick={() => navigate('/payment3')} 
                  className="w-fit px-8 py-3 shadow-lg   font-bold text-[#13294b] bg-[#FFD367] rounded-full"
                >
                  Save & Continue
                </button>
              </form>
            </div>

          )}
        </div>

        {/* Order Summary */}
        <div className="w-full md:pl-14 mt-6 md:mt-0">

        <div className="bg-white p-8 rounded-lg shadow-lg ">
          <h2 className="mb-4 text-lg font-bold sm:text-xl">Order Summary</h2>
          <div className="pb-2 mb-4 border-b">
            <div className="flex justify-between text-sm text-gray-700 sm:text-base">
              <span>Subtotal</span>
              <span>AED {total.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-sm text-gray-700 sm:text-base">
              <span>Shipping</span>
              <span>To be calculated</span>
            </div>
            <div className="flex justify-between text-sm text-gray-700 sm:text-base">
              <span>Tax</span>
              <span>To be calculated</span>
            </div>
          </div>



          
          <div className="flex justify-between text-sm font-bold sm:text-lg">
            <span>Amount Due</span>
            <span>AED  {total.toFixed(2)}</span>
          </div>


          
 
        </div>
              </div>
      </div>
    </div>
  );
}
